import React, { CSSProperties, useEffect, useState } from "react";
import { PuffLoader } from "react-spinners";
import MascotLogo from "../../../assets/theme/images/macot-orange-loader.png";

interface LoadingLogoSpinnerProps {
  loading?: boolean;
  small?: boolean; // ⬅️ Add this prop to switch behavior
  size?: number;
}

const override: CSSProperties = {
  display: "block",
  margin: "0 auto",
  position: "absolute"
};

const colors = [
  "#8B00FF",
  "#4B0082",
  "#0000FF",
  "#008000",
  "#FFFF00",
  "#FFA500",
  "#FF0000",
];

const LoadingLogoSpinner: React.FC<LoadingLogoSpinnerProps> = ({
  loading,
  small = false,
  size = 50,
}) => {
  const [colorIndex, setColorIndex] = useState(0);

  useEffect(() => {
    if (!loading || small) return;

    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 500);

    return () => clearInterval(interval);
  }, [loading, small]);

  if (!loading) return null;

  return (
    <div className="flex flex-col items-center justify-center gap-2">
      {small ? (
        <img
          src={MascotLogo}
          alt="Mascot Logo"
          className="w-6 h-6 object-contain animate-spin"
        />
      ) : (
        <>
          <PuffLoader
            cssOverride={override}
            size={size}
            color={colors[colorIndex]}
            loading={loading}
          />
          <img
            src={MascotLogo}
            alt="Mascot Logo"
            className="w-8 h-8 object-contain"
          />
        </>
      )}
    </div>
  );
};

export default LoadingLogoSpinner;
